import { LINK_ERROR_MESSAGE } from "../../../../../constants/block/LinkData";
import { isValidUrl } from "../../../../../utils/common/block/links/isValidUrl";
import LinkAddDialogError from "./Error";
import LinkAddDialogLinkName from "./LinkName";
import LinkAddDialogUrlInput from "./UrlInput";
import clsx from "clsx";
import { LinkClientData } from "../../../../../views/TaskDetail/Link/type";
interface LinkAddDialogMainProps {
  linkNameInput: string;

  debouncedValue: string;

  handleLinkNameInputChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  setDebouncedValue: (value: string) => void;
  showBottomUI: boolean;
  isFetching: boolean;
  isUrlModified: boolean;
  setIsUrlModified: (value: boolean) => void;
  initData: LinkClientData | null;

  setIsLinkNameModified: (value: boolean) => void;
}

const LinkAddDialogMain = ({
  linkNameInput,
  debouncedValue,
  setDebouncedValue,
  handleLinkNameInputChange,
  showBottomUI,
  isFetching,
  initData,
  isUrlModified,
  setIsUrlModified,
  setIsLinkNameModified,
}: LinkAddDialogMainProps) => {
  const bottomUIClasses = clsx(
    "flex w-full flex-col gap-2 overflow-hidden  transition-all duration-200",
    {
      "pointer-events-auto max-h-40 translate-y-0 opacity-100 px-1 pt-5": showBottomUI,
      "pointer-events-none max-h-0 translate-y-2 opacity-0": !showBottomUI,
    }
  );

  const renderBottomContent = () => {
    if (!debouncedValue) return null;

    if (!isValidUrl(debouncedValue)) {
      return <LinkAddDialogError error={LINK_ERROR_MESSAGE.INVALID_URL} />;
    }

    return (
      <LinkAddDialogLinkName
        isFetching={isFetching}
        debouncedValue={debouncedValue}
        linkNameInput={linkNameInput}
        handleLinkNameInputChange={handleLinkNameInputChange}
      />
    );
  };

  return (
    <div
      className={`flex flex-1 flex-col items-center justify-center gap-[10px] px-[15px] pb-[40px] pt-[20px]`}
    >
      <LinkAddDialogUrlInput
        initData={initData}
        isUrlModified={isUrlModified}
        setIsUrlModified={setIsUrlModified}
        setDebouncedValue={setDebouncedValue}
        setIsLinkNameModified={setIsLinkNameModified}
      />
      <div
        className={bottomUIClasses}
        style={{ minHeight: showBottomUI ? 56 : 0 }}
      >
        {renderBottomContent()}
      </div>
    </div>
  );
};

export default LinkAddDialogMain;
